<template>
  <div>
    <transition name="lqv-fade">
      <div v-if="show" class="lqv-overlay" @click="close()"></div>
    </transition>

    <transition :name="side === 'left' ? 'lqv-slide-left' : 'lqv-slide-right'">
      <aside
        v-if="show"
        class="lqv-panel"
        :class="side === 'left' ? 'lqv-panel--left' : 'lqv-panel--right'"
        role="dialog"
        aria-modal="true"
        aria-label="Lead kartı"
      >
        <header class="lqv-header">
          <div class="flex items-center space-x-2 min-w-0">
            <button
              type="button"
              class="lqv-icon-button"
              title="Önceki kayıt (←)"
              :disabled="!hasPrev || loadingPage"
              @click="go(-1)"
            >
              <svg class="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="m10.8 12l3.9 3.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275l-4.6-4.6q-.15-.15-.213-.325T8.425 12t.063-.375t.212-.325l4.6-4.6q.275-.275.7-.275t.7.275t.275.7t-.275.7z"
                />
              </svg>
            </button>
            <button
              type="button"
              class="lqv-icon-button"
              title="Sonraki kayıt (→)"
              :disabled="!hasNext || loadingPage"
              @click="go(1)"
            >
              <svg class="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M12.6 12L8.7 8.1q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.6 4.6q.15.15.213.325t.062.375t-.062.375t-.213.325l-4.6 4.6q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7z"
                />
              </svg>
            </button>
            <vk-spinner v-if="loadingPage" ratio="0.5" class="text-gray-400" />
            <span
              v-else-if="ids.length > 1 || pageInfo.pages > 1"
              class="text-xs text-gray-500 whitespace-nowrap"
            >
              <template v-if="pageInfo.pages > 1"
                >Sayfa {{ pageInfo.page }}/{{ pageInfo.pages }} ·
              </template>
              {{ index + 1 }} / {{ ids.length }}
            </span>
          </div>

          <div class="flex items-center space-x-1">
            <button
              type="button"
              class="lqv-icon-button hidden md:inline-flex"
              :title="side === 'left' ? 'Sağda aç' : 'Solda aç'"
              @click="toggleSide()"
            >
              <svg class="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v14q0 .825-.587 1.413T19 21zm10-2h4V5h-4zm-2 0V5H5v14zm2 0h4z"
                  :transform="side === 'left' ? 'matrix(-1 0 0 1 24 0)' : null"
                />
              </svg>
            </button>
            <router-link
              :to="'/leadDetail/' + currentId"
              class="lqv-icon-button"
              title="Tam sayfada aç"
            >
              <svg class="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h6q.425 0 .713.288T12 4t-.288.713T11 5H5v14h14v-6q0-.425.288-.712T20 12t.713.288T21 13v6q0 .825-.587 1.413T19 21zM19 6.4L10.4 15q-.275.275-.7.275T9 15t-.275-.7t.275-.7L17.6 5H15q-.425 0-.712-.288T14 4t.288-.712T15 3h5q.425 0 .713.288T21 4v5q0 .425-.288.713T20 10t-.712-.288T19 9z"
                />
              </svg>
            </router-link>
            <button
              type="button"
              class="lqv-icon-button"
              title="Kapat (Esc)"
              @click="close()"
            >
              <svg class="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6L6.4 19Z"
                />
              </svg>
            </button>
          </div>
        </header>

        <div ref="body" class="lqv-body">
          <LeadDetail
            ref="detail"
            :key="currentId"
            :lead-id="currentId"
            :embedded="true"
          />
        </div>
      </aside>
    </transition>
  </div>
</template>

<script>
import EventBus from "../EventBus";

const SIDE_KEY = "leadQuickViewSide";

function readSide() {
  try {
    return localStorage.getItem(SIDE_KEY) === "left" ? "left" : "right";
  } catch (e) {
    return "right";
  }
}

export default {
  name: "LeadQuickView",
  components: {
    // LeadDetail -> components döngüsünü kırmak için tembel yükleme
    LeadDetail: () => import("../../../views/LeadDetail.vue"),
  },
  data() {
    return {
      show: false,
      ids: [],
      index: 0,
      // Listeyi sağlayan tablo: sayfa sonunda sonraki sayfayı yükletmek için
      source: null,
      loadingPage: false,
      // Bu oturumda gezilen kayıtlar: sayfa kaymasında tekrar gösterme
      seen: {},
      side: readSide(),
      bodyOverflow: "",
    };
  },
  computed: {
    currentId() {
      return this.ids[this.index];
    },
    hasPrev() {
      return this.index > 0 || this.canLoadPage(-1);
    },
    hasNext() {
      return this.index < this.ids.length - 1 || this.canLoadPage(1);
    },
    pageInfo() {
      return this.source && this.source.pageInfo
        ? this.source.pageInfo()
        : { page: 1, pages: 1 };
    },
  },
  watch: {
    currentId(id) {
      if (id) {
        this.seen[id] = true;
      }
      if (this.show && id) {
        EventBus.$emit("leadQuickViewActive", { id });
      }
    },
    "$route.path"() {
      // Tam sayfaya geçildiğinde ya da başka sayfaya gidildiğinde kapat
      if (this.show) {
        this.close(true);
      }
    },
  },
  methods: {
    open(payload) {
      const id = payload && payload.id;
      if (!id) {
        return;
      }
      const ids = (payload.ids && payload.ids.length ? payload.ids : [id]).map(
        (value) => String(value)
      );
      let index = ids.indexOf(String(id));
      if (index === -1) {
        ids.unshift(String(id));
        index = 0;
      }
      this.ids = ids;
      this.index = index;
      this.source = payload.source || null;
      this.seen = {};
      this.seen[ids[index]] = true;
      if (!this.show) {
        this.show = true;
        this.lockScroll();
      }
      EventBus.$emit("leadQuickViewActive", { id: this.currentId });
    },
    confirmLeave() {
      const detail = this.$refs.detail;
      if (detail && typeof detail.isEditing === "function" && detail.isEditing()) {
        return confirm("Kaydedilmemiş değişiklikler var. Devam edilsin mi?");
      }
      return true;
    },
    canLoadPage(step) {
      return !!(this.source && this.source.canLoadPage(step));
    },
    scrollTop() {
      if (this.$refs.body) {
        this.$refs.body.scrollTop = 0;
      }
    },
    go(step) {
      if (this.loadingPage) {
        return;
      }
      const next = this.index + step;
      if (next >= 0 && next < this.ids.length) {
        if (!this.confirmLeave()) {
          return;
        }
        this.index = next;
        this.scrollTop();
        return;
      }
      // Sayfanın sonu/başı: listeyi bir sonraki/önceki sayfaya geçir
      if (!this.canLoadPage(step) || !this.confirmLeave()) {
        return;
      }
      this.loadingPage = true;
      const request = step > 0 ? this.nextFromRefreshedPage() : this.loadPage(-1);
      request
        .catch(() => {
          this.$root.errorMessage("Sayfa yüklenemedi");
        })
        .finally(() => {
          this.loadingPage = false;
        });
    },
    applyPage(ids, index) {
      if (!this.show || !ids.length) {
        return;
      }
      this.ids = ids;
      this.index = Math.min(Math.max(index, 0), ids.length - 1);
      this.scrollTop();
    },
    loadPage(step) {
      return this.source.loadPage(step).then((ids) => {
        const list = ids.map((value) => String(value));
        if (step < 0) {
          this.applyPage(list, list.length - 1);
          return;
        }
        // Liste aşağı kaydıysa (yeni kayıt eklendiyse) görülmüşleri atla
        const firstUnseen = list.findIndex((id) => !this.seen[id]);
        this.applyPage(list, firstUnseen === -1 ? 0 : firstUnseen);
      });
    },
    // Filtreli listede gezilen kayıtlar filtreden düşmüş olabilir; o zaman sonraki
    // sayfadaki kayıtlar bu sayfaya kayar ve doğrudan sonraki sayfaya geçmek onları
    // atlar. Önce bu sayfayı tazeleyip henüz görülmemiş kayıt var mı bakılır.
    nextFromRefreshedPage() {
      const oldIds = this.ids.slice(0, this.index + 1);
      return this.source.loadPage(0).then((ids) => {
        const list = ids.map((value) => String(value));
        let anchor = -1;
        for (let i = oldIds.length - 1; i >= 0 && anchor === -1; i--) {
          anchor = list.indexOf(oldIds[i]);
        }
        const nextUnseen = list.findIndex(
          (id, position) => position > anchor && !this.seen[id]
        );
        if (nextUnseen !== -1) {
          this.applyPage(list, nextUnseen);
          return;
        }
        if (!this.canLoadPage(1)) {
          // Son sayfa: tazelenmiş listede kaldığı yerde dur
          this.applyPage(list, anchor === -1 ? list.length - 1 : anchor);
          return;
        }
        return this.loadPage(1);
      });
    },
    close(force) {
      if (!this.show || (!force && !this.confirmLeave())) {
        return;
      }
      const id = this.currentId;
      this.show = false;
      this.source = null;
      this.seen = {};
      this.unlockScroll();
      EventBus.$emit("leadQuickViewClosed", { id });
    },
    toggleSide() {
      this.side = this.side === "left" ? "right" : "left";
      try {
        localStorage.setItem(SIDE_KEY, this.side);
      } catch (e) {
        // yok say
      }
    },
    lockScroll() {
      this.bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    },
    unlockScroll() {
      document.body.style.overflow = this.bodyOverflow;
    },
    isTyping(event) {
      const target = event.target;
      if (!target) {
        return false;
      }
      const tag = (target.tagName || "").toLowerCase();
      return (
        tag === "input" ||
        tag === "textarea" ||
        tag === "select" ||
        target.isContentEditable
      );
    },
    onKeydown(event) {
      if (!this.show || event.defaultPrevented) {
        return;
      }
      // Drawer içinden açılan UIkit modal'ı varsa ona öncelik ver
      if (document.querySelector(".uk-modal.uk-open")) {
        return;
      }
      if (event.key === "Escape") {
        this.close();
        return;
      }
      if (this.isTyping(event) || event.altKey || event.ctrlKey || event.metaKey) {
        return;
      }
      if (event.key === "ArrowLeft") {
        this.go(-1);
      } else if (event.key === "ArrowRight") {
        this.go(1);
      }
    },
  },
  mounted() {
    EventBus.$on("leadQuickViewOpen", this.open);
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    EventBus.$off("leadQuickViewOpen", this.open);
    window.removeEventListener("keydown", this.onKeydown);
    if (this.show) {
      this.unlockScroll();
    }
  },
};
</script>

<style>
/* İki temada da (yan menü / üst menü) menülerin ve mobil alt menünün üstünde,
   UIkit modallarının (1010) altında kalır. */
.lqv-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  background-color: rgba(17, 24, 39, 0.4);
}

.lqv-panel {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1002;
  width: 100%;
  display: flex;
  flex-direction: column;
  @apply bg-pampas shadow-xl;
}

.lqv-panel--right {
  right: 0;
  @apply border-l border-gray-200;
}

.lqv-panel--left {
  left: 0;
  @apply border-r border-gray-200;
}

@media (min-width: 768px) {
  .lqv-panel {
    width: 92vw;
  }
}

@media (min-width: 1280px) {
  .lqv-panel {
    width: 1180px;
  }
}

.lqv-header {
  @apply flex items-center justify-between px-3 py-2 bg-white border-b border-gray-200 flex-shrink-0;
  min-height: 52px;
}

.lqv-body {
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.lqv-icon-button {
  @apply inline-flex items-center justify-center w-9 h-9 rounded-lg text-gray-600 bg-transparent border-0 cursor-pointer;
}

.lqv-icon-button:hover {
  @apply bg-gray-100 text-tile-500;
}

.lqv-icon-button:disabled {
  @apply opacity-40 cursor-not-allowed;
}

.lqv-icon-button:disabled:hover {
  @apply bg-transparent text-gray-600;
}

.lqv-fade-enter-active,
.lqv-fade-leave-active {
  transition: opacity 0.2s ease;
}

.lqv-fade-enter,
.lqv-fade-leave-to {
  opacity: 0;
}

.lqv-slide-right-enter-active,
.lqv-slide-right-leave-active,
.lqv-slide-left-enter-active,
.lqv-slide-left-leave-active {
  transition: transform 0.25s ease;
}

.lqv-slide-right-enter,
.lqv-slide-right-leave-to {
  transform: translateX(100%);
}

.lqv-slide-left-enter,
.lqv-slide-left-leave-to {
  transform: translateX(-100%);
}

@media (prefers-reduced-motion: reduce) {
  .lqv-fade-enter-active,
  .lqv-fade-leave-active,
  .lqv-slide-right-enter-active,
  .lqv-slide-right-leave-active,
  .lqv-slide-left-enter-active,
  .lqv-slide-left-leave-active {
    transition: none;
  }
}
</style>
